import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

import { MatDialog } from "@angular/material/dialog";
import * as _ from "lodash";
import { Papa } from "ngx-papaparse";
import {
  ThirdPartyReportNote,
  Client,
  User,
  UserView,
} from "@deliver-sense-librarian/data-schema";
import { AngularFirestore } from "@angular/fire/firestore";
import { takeUntil, first } from "rxjs/operators";
import { Subject, lastValueFrom } from "rxjs";
import { Store } from "@ngrx/store";
import moment from "moment";
import { ReconciliationNoteDialogComponent } from "app/dialogs/reconciliation-note-dialog/reconciliation-note-dialog.component";
import { downloadDataAsFile } from "app/shared/ds-constant";
import { FirestoreUtilities } from "app/utilities/firestore-utilities";
import { ReconciliationReportExportUtility } from "../../utilities/reconciliation-report-export.utility";
import { ReconciliationReportDatUtility } from "../../utilities/reconciliation-report-data.utility";
import { ConfirmDialogComponent } from "app/dialogs/confirm-dialog/confirm-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
@Component({
  selector: "app-reconciliation-notes",
  templateUrl: "./reconciliation-notes.component.html",
  styleUrls: ["./reconciliation-notes.component.scss"],
})
export class ReconciliationNotesComponent implements OnInit, OnDestroy {
  @Input() dataUtility: ReconciliationReportDatUtility;
  @Input() exportUtility: ReconciliationReportExportUtility;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  public tableData: MatTableDataSource<any>;
  public displayedColumns: string[] = [
    "locations",
    "thirdParties",
    "date",
    "creator",
    "message",
    "edit",
    "delete",
  ];
  public thirdPartyReportNotes: ThirdPartyReportNote[];
  private destroy$ = new Subject();
  constructor(
    private cdr: ChangeDetectorRef,
    private afs: AngularFirestore,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private papa: Papa
  ) {}

  ngOnInit() {
    this.getReportNotes();
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private async getReportNotes() {
    // const clientPersistantNotes = FirestoreUtilities.mapToType(
    //   await lastValueFrom(
    //     this.afs
    //       .collection("thirdPartyReportNotes", (ref) =>
    //         ref
    //           .where("client", "==", this.dataUtility.client.id)
    //           .where("isPersistant", "==", true)
    //       )
    //       .snapshotChanges()
    //       .pipe(first())
    //   )
    // )
    this.afs
      .collection("thirdPartyReportNotes", (ref) =>
        ref
          .where("client", "==", this.dataUtility.client.id)
          .where("thirdPartyReport", "==", this.dataUtility.existingReport.id)
      )
      .snapshotChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (queryResults$) => {
        const thirdPartyReportNotes = <ThirdPartyReportNote[]>(
          FirestoreUtilities.mapToType(queryResults$).filter(
            (note: ThirdPartyReportNote) => {
              let locationsFound = false;
              let thirdPartiesFound = false;
              note.thirdParties.forEach((thirdPartyId) => {
                if (
                  this.dataUtility.existingReport.thirdParties.indexOf(
                    thirdPartyId
                  ) > -1
                ) {
                  thirdPartiesFound = true;
                }
              });
              note.locations.forEach((locationId) => {
                if (
                  this.dataUtility.existingReport.locations.indexOf(
                    locationId
                  ) > -1
                ) {
                  locationsFound = true;
                }
              });

              return locationsFound && thirdPartiesFound;
            }
          )
        );
        await this.setDataNames(thirdPartyReportNotes);
        this.thirdPartyReportNotes = [
          // ...clientPersistantNotes,
          ...thirdPartyReportNotes,
        ];
        this.setTableData();
      });
  }
  private async setDataNames(thirdPartyReportNotes) {
    const creatorQuerys = thirdPartyReportNotes.map((thirdPartyReportNote) => {
      return this.afs
        .doc(`userViews/${thirdPartyReportNote.creator}`)
        .snapshotChanges()
        .pipe(first())
        .toPromise();
    });
    const creatorUserViews = <UserView[]>(
      FirestoreUtilities.mergeToType(await Promise.all(creatorQuerys))
    );
    thirdPartyReportNotes.forEach((thirdPartyReportNote) => {
      const creatorUserView = creatorUserViews.find(
        (userView) => userView.id === thirdPartyReportNote.creator
      );
      if (creatorUserView) {
        thirdPartyReportNote["creatorEmail"] = creatorUserView.email;
      }
    });
    thirdPartyReportNotes.forEach((thirdPartyReportNote) => {
      //@TODO wtf
      //@ts-ignore
      thirdPartyReportNote["thirdPartyNames"] =
        thirdPartyReportNote.thirdParties.reduce((txt, thirdPartyId) => {
          console.log(thirdPartyId);
          const thirdPartyName =
            this.dataUtility.getThirdPartyName(thirdPartyId);
          console.log(thirdPartyName);
          if (!txt) {
            return `${thirdPartyName}`;
          } else {
            return `${txt}, ${thirdPartyName}`;
          }
        }, ``);
    });
  }

  setTableData() {
    this.tableData = new MatTableDataSource(this.thirdPartyReportNotes);
    this.tableData.paginator = this.paginator;
    this.tableData.sort = this.sort;
    this.cdr.detectChanges();
  }
  public upsertNote(reportNote?: ThirdPartyReportNote) {
    let note;
    if (reportNote) {
      note = this.thirdPartyReportNotes.find(
        (reportNoteOriginal) => reportNoteOriginal.id === reportNote.id
      );
    } else {
      note = new ThirdPartyReportNote();
    }
    this.dialog.open(ReconciliationNoteDialogComponent, {
      panelClass: "invisible-panel-dialog",
      data: {
        thirdPartyReportNote: note,
        locations: this.dataUtility.locations,
        thirdParties: this.dataUtility.thirdParties,
        client: this.dataUtility.client,
        creator: this.dataUtility.user,
        thirdPartyReportId: this.dataUtility.existingReport.id,
      },
    });
  }
  public applyFilter(filterValue: string) {
    this.tableData.filter = filterValue.trim().toLowerCase();
    if (this.tableData.paginator) {
      this.tableData.paginator.firstPage();
    }
  }
  exportReport() {
    const data = this.thirdPartyReportNotes.map((note) => {
      //@ts-ignore
      const thirdPartiesText = note.thirdParties.reduce((txt, dspId) => {
        if (txt) {
          return `${txt}, ${this.dataUtility.getThirdPartyName(dspId)}`;
        } else {
          return this.dataUtility.getThirdPartyName(dspId);
        }
      }, "");
      return {
        Locations: note.locations,
        "3PDs": thirdPartiesText,
        Dates: note.dates
          ? note.dates.map((date) => `${moment(date.toDate()).format("l")} `)
          : note.startDate
          ? moment(note.startDate.toDate()).format("M/D/YYYY")
          : "",
        Creator: note.creator,
        Message: note.message,
      };
    });
    const results = this.papa.unparse(data, {
      quotes: false,
      quoteChar: '"',
      escapeChar: '"',
      delimiter: ",",
      header: true,
      newline: "\r\n",
      skipEmptyLines: false,
    });
    const fileName = `${this.dataUtility.existingReport.name}-Reconciliation-Notes`;
    downloadDataAsFile(results, fileName, "csv");
  }
  async deleteNote(note: ThirdPartyReportNote) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Confirm Delete Reconciliation Note",
        message: `Are you sure you want delete this note?`,
        action: "Yes, Delete.",
      },
    });
    dialogRef.afterClosed().subscribe(async (confirmed) => {
      if (confirmed) {
        await this.afs.doc(`thirdPartyReportNotes/${note.id}`).delete();
        this.snackBar.open("Report note deleted successfully!", "Dismiss", {
          duration: 5000,
        });
      }
    });
  }
}
